import { useTheme } from "@emotion/react";
import {
  Add,
  Delete,
  Edit,
  ErrorOutlineOutlined,
  MoreVertOutlined,
  PublicOffOutlined,
  PublicOutlined,
  ReportProblemOutlined,
} from "@mui/icons-material";
import {
  Button,
  Chip,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Paper,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import useStyles from "./styles";
import { useEffect, useState } from "react";
import api from "../../../services/api";
import InternoModalConfirmacaoSaida from "../../modalSaindoDaPagina";
import CopyButton from "../shared/copyButton";
import SectionCard from "../shared/sectionCard";
export default function RfoComponent(params) {
  const {
    ticketDetails,
    setTicketDetails = () => {},
    setSnackbar = () => {},
    setItensPublic = () => {},
    itensPublic = [],
    isEdit = false,
  } = params;

  const [rfo, setRfo] = useState({ id: "", causa: "", solucao: "" });
  const [editRfo, setEditRfo] = useState(false);
  const [error, setError] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const theme = useTheme();
  const styles = useStyles(theme);
  const [anchorEl, setAnchorEl] = useState(null);
  const [deleteLoad, setDeleteLoad] = useState(false);
  const [rfoPublic, setRfoPublic] = useState(itensPublic?.rfo);
  const open = Boolean(anchorEl);
  const deleteBody =
    "O RFO será excluído permanentemente. Deseja excluir o RFO?";

  const confirmDelete = "Excluir";
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    setRfo((prev) => ({
      ...prev,
      id: ticketDetails?.rfo?.id,
      causa: ticketDetails?.rfo?.causa,
      solucao: ticketDetails?.rfo?.solucao,
    }));
  }, [ticketDetails]);

  const createRfo = async () => {
    if (!rfo?.causa?.trim() || !rfo?.solucao?.trim()) {
      setError(true);
      return;
    }

    try {
      const response = await api.post("/interno/create/rfo", {
        ticketId: ticketDetails?.id_atendimento?.toString(),
        causeProblem: rfo?.causa?.trim(),
        solutionProblem: rfo?.solucao?.trim(),
      });
      setTicketDetails((prev) => ({
        ...prev,
        rfo: {
          id: response?.data?.id,
          causa: response?.data.causeProblem,
          solucao: response?.data?.solutionProblem,
        },
      }));
      setEditRfo(false);
      setRfo((prev) => ({
        ...prev,
        id: response?.data?.id,
        causa: response?.data.causeProblem,
        solucao: response?.data?.solutionProblem,
      }));
      setSnackbar({
        children: "RFO criado",
        severity: "success",
      });
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: "Erro ao criar RFO",
        severity: "error",
      });
    } finally {
      setError(false);
    }
  };

  const createItensPublic = async (ticketId, itemType, itensId) => {
    try {
      const response = await api.post("/interno/create/itemPublic", {
        ticketId: ticketId,
        itemType: itemType,
        itensId: itensId,
      });
      setSnackbar({
        children: "Itens publicado para o cliente!",
        severity: "success",
      });

      return response?.data;
    } catch (error) {
      console.log(error);
      setSnackbar({
        children: "Error: Não foi possível publicar itens",
        severity: "error",
      });
    } finally {
    }
  };

  const publicRfoClient = async (rfoId) => {
    try {
      const response = await createItensPublic(
        ticketDetails?.id_atendimento,
        "rfo",
        rfoId,
      );
      if (!response) {
        return;
      }
      setItensPublic((prev) => ({ ...prev, rfo: response }));
      setRfoPublic(rfoId);
      handleClose();
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const updateRfo = async () => {
    if (!rfo?.causa?.trim() || !rfo?.solucao?.trim()) {
      setError(true);
      return;
    }
    try {
      const response = await api.post("/interno/edit/rfo", {
        rfoId: rfo?.id,
        causeProblem: rfo?.causa,
        solutionProblem: rfo?.solucao,
      });
      setTicketDetails((prev) => ({
        ...prev,
        rfo: {
          id: response?.data?.id,
          causa: response?.data?.causeProblem?.trim(),
          solucao: response?.data?.solutionProblem?.trim(),
        },
      }));
      setEditRfo(false);
      setRfo((prev) => ({
        ...prev,
        id: response?.data?.id,
        causa: response?.data?.causeProblem,
        solucao: response?.data?.solutionProblem,
      }));
      setSnackbar({
        children: "RFO atualizado",
        severity: "success",
      });
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: "Erro ao atualizar RFO",
        severity: "error",
      });
    } finally {
      setError(false);
    }
  };

  const deleteRfo = async () => {
    setDeleteLoad(true);
    try {
      const response = await api.post("/interno/delete/rfo", {
        rfoId: rfo?.id,
      });
      setTicketDetails((prev) => ({
        ...prev,
        rfo: null,
      }));
      setEditRfo(false);
      setRfo((prev) => ({
        ...prev,
        id: "",
        causa: "",
        solucao: "",
      }));
      setSnackbar({
        children: "RFO excluído",
        severity: "success",
      });
      setRfoPublic([]);
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: "Erro ao excluir RFO",
        severity: "error",
      });
    } finally {
      setDeleteLoad(false);
      setOpenDeleteModal(false);
    }
  };

  const temRfo = Boolean(ticketDetails?.rfo);
  const publicado = rfoPublic?.length > 0;

  // Em modo de leitura o RFO é um relatório, não um formulário: mostrar o
  // conteúdo em TextField desabilitado deixava o texto cinza e sem seleção
  // confortável. O formulário só aparece quando se está de fato editando.
  const blocoLeitura = (titulo, texto, rotuloCopia) => (
    <Box sx={styles.blocoLeitura}>
      <Box sx={styles.blocoLeituraHeader}>
        <Typography sx={styles.blocoLeituraTitulo}>{titulo}</Typography>
        {texto && (
          <CopyButton
            value={texto}
            setSnackbar={setSnackbar}
            title={`Copiar ${rotuloCopia}`}
            mensagem={`${titulo} copiada!`}
          />
        )}
      </Box>
      {texto ? (
        <Typography sx={styles.blocoLeituraTexto}>{texto}</Typography>
      ) : (
        <Typography sx={styles.textoVazio}>Não informado.</Typography>
      )}
    </Box>
  );

  return (
    <Box sx={styles.container}>
      <SectionCard
        icon={<ErrorOutlineOutlined sx={styles.iconSecao} />}
        title="RFO"
        action={
          <>
            {publicado && (
              <Tooltip title="RFO publicada para o cliente">
                <Chip
                  size="small"
                  label="Publicado"
                  sx={styles.chipSelect}
                  icon={<PublicOutlined sx={styles.chipStatusAnexoIcon} />}
                />
              </Tooltip>
            )}
            {!editRfo && isEdit && temRfo && (
              <Tooltip title="Mais ações">
                <IconButton onClick={handleClick} size="small">
                  <MoreVertOutlined fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </>
        }
        sx={{ pb: 3 }}
      >
        {!editRfo && !temRfo ? (
          <Box sx={styles.containerWarnig}>
            <ReportProblemOutlined sx={styles.iconeVazio} />
            <Typography sx={styles.titleWarning}>
              Nenhum RFO cadastrado
            </Typography>
            <Typography sx={styles.subtituloVazio}>
              O relatório de falha de operação registra a causa e a solução do
              problema atendido.
            </Typography>
            {isEdit && !ticketDetails?.configTicket && (
              <Button
                startIcon={<Add />}
                onClick={() => setEditRfo(true)}
                sx={{ marginTop: "20px" }}
                variant="contained"
              >
                Adicionar RFO
              </Button>
            )}
          </Box>
        ) : editRfo ? (
          <Box sx={styles.boxBody}>
            <Box sx={styles.containerTextfield}>
              <Typography sx={styles.rotuloCampo}>Causa do problema</Typography>
              <TextField
                value={rfo?.causa}
                error={!rfo?.causa?.trim() && error}
                helperText={
                  !rfo?.causa?.trim() && error
                    ? "Causa do problema é obrigatório"
                    : ""
                }
                placeholder="Descreva o que causou o problema"
                multiline
                minRows={5}
                maxRows={12}
                sx={styles.campoTexto}
                onChange={(e) =>
                  setRfo((prev) => ({
                    ...prev,
                    causa: e.target.value,
                  }))
                }
              />
            </Box>

            <Box sx={styles.containerTextfield}>
              <Typography sx={styles.rotuloCampo}>
                Solução do problema
              </Typography>
              <TextField
                value={rfo?.solucao}
                error={!rfo?.solucao?.trim() && error}
                helperText={
                  !rfo?.solucao?.trim() && error
                    ? "Solução do problema é obrigatório"
                    : ""
                }
                onChange={(e) =>
                  setRfo((prev) => ({
                    ...prev,
                    solucao: e.target.value,
                  }))
                }
                placeholder="Descreva a solução"
                multiline
                minRows={5}
                maxRows={12}
                sx={styles.campoTexto}
              />
            </Box>

            {isEdit && (
              <Box sx={styles.containerButtons}>
                <Button
                  onClick={() => setEditRfo(false)}
                  sx={styles.botaoCancelar}
                  variant="outlined"
                >
                  Cancelar
                </Button>
                {!ticketDetails?.rfo ? (
                  <Button onClick={createRfo} variant="contained">
                    Criar
                  </Button>
                ) : (
                  <Button onClick={updateRfo} variant="contained">
                    Atualizar
                  </Button>
                )}
              </Box>
            )}
          </Box>
        ) : (
          <Box sx={styles.boxBody}>
            {blocoLeitura("Causa do problema", rfo?.causa, "a causa")}
            {blocoLeitura("Solução do problema", rfo?.solucao, "a solução")}
          </Box>
        )}
      </SectionCard>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <MenuItem
          onClick={() => {
            handleClose();
            setEditRfo(true);
          }}
        >
          <ListItemIcon>
            <Edit fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Editar" />
        </MenuItem>
        {rfoPublic?.length === 0 ? (
          <MenuItem
            onClick={() => {
              publicRfoClient([ticketDetails?.rfo?.id]);
            }}
          >
            <ListItemIcon>
              <PublicOutlined fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Publicar" />
          </MenuItem>
        ) : (
          <MenuItem
            onClick={() => {
              publicRfoClient([]);
            }}
          >
            <ListItemIcon>
              <PublicOffOutlined fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Ocultar" />
          </MenuItem>
        )}

        <MenuItem
          onClick={() => {
            setOpenDeleteModal(true);
          }}
        >
          <ListItemIcon>
            <Delete color="error" fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Excluir" />
        </MenuItem>
      </Menu>

      <InternoModalConfirmacaoSaida
        openConfirmacao={openDeleteModal}
        load={deleteLoad}
        setOpenConfirmacao={setOpenDeleteModal}
        execute={() => {
          deleteRfo();
          handleClose();
        }}
        title={"Atencão"}
        severity={"error"}
        contentText={deleteBody}
        confirmText={confirmDelete}
      />
    </Box>
  );
}
